// api/statistics.js
import axios from 'axios'
import qs from 'qs'
const BASE_URL = window.__APP_CONFIG__.apiBaseUrl


export function addAccessStatistics(params = {}) {
    const finalParams = {
        ...params
    }

    return axios.post(
        `${BASE_URL}/accessStatistics/addAccessStatistics`,
        qs.stringify(finalParams),
        {
            headers: {
                'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
                customerId: localStorage.getItem('token')
            },
        }
    )
}
